import { useAuthStore } from '@/stores/auth.ts';

/**
 * Stashes the `#token=...` of a `?scope=partner` MFA link as the partner-scope bearer used by the MFA pages.
 * It is never promoted to the SPA session, so the user's own `uzzer_token` cookie stays untouched.
 */
export const fragmentParser = (fragment: string) => {
	const params = new URLSearchParams(window.location.search);
	const scope = params.get('scope');
	if (scope === 'partner') {
		const hashParams = new URLSearchParams(fragment);
		const partnerToken = hashParams.get('token');
		if (partnerToken) {
			sessionStorage.setItem('partner_token', partnerToken);
			useAuthStore().partnerToken = partnerToken;
		}
	}
};
